<template>
  <div class="campaign">
    <div class="campaign__header">
      <h2 class="medium-title">Campaign</h2>
      <span class="campaign__header__new" @click.stop="newCampaign">new campaign</span>
    </div>
    <div class="campaign__action">
      <div class="campaign__action__search">
        <i class="adx-ic_search"></i>
        <input type="text" name="search" id="search" placeholder="Search" autocomplete="off" v-model="searchCampaign">
      </div>
    </div>
    <div class="campaign__main">
      <table class="table_campaign" v-if="!isLoading && !isEmpty">
        <thead>
          <th>Campaign Name</th>
          <th>Period</th>
          <th>Total Location</th>
          <th>Total Placement</th>
          <th>Total Assignee</th>
        </thead>
        <tbody>
          <tr v-for="campaign in campaigns" :key="campaign.id">
            <td>{{campaign.title}}</td>
            <td>{{formatDate(campaign.start, campaign.end)}}</td>
            <td>{{campaign.total_location}} Location</td>
            <td>{{campaign.total_placement}} Placement</td>
            <td>
              <div class="action">
                <span>{{campaign.total_assignee}} Assignee</span>
                <span class="action__edit" @click.stop="goToDetail(campaign.id)"><i class="adx-ic_edit"></i></span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="table_campaign__loading" v-else-if="isLoading"><loading-primary /></div>
      <div v-if="isEmpty" class="table_campaign__emptyState"><adx-empty-selection/></div>
    </div>
    <div class="campaign__page">
      <adx-pagination :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import LoadingPrimary from '@/components/Loading/Primary'
import EmptySelection from '@/components/NotFound/Selection'
import Pagination from '@/components/Pagination'
import * as validationLib from '@/lib/validation/'
import api from '@/api'
import { apiV2 } from '@/api/urls'

const {
  helpers
} = validationLib

export default {
  name: 'adx-monitoring-campaign',
  components: {
    'adx-pagination': Pagination,
    'loading-primary': LoadingPrimary,
    'adx-empty-selection': EmptySelection
  },
  props: {

  },
  data() {
    return {
      selectedPage: 1,
      maxPage: 0,
      campaigns: [],
      searchCampaign: '',
      isEmpty: false,
      isLoading: false
    }
  },
  computed: {
    getFilterParams: function () {
      const params = {
        page: this.selectedPage || undefined,
        search: this.searchCampaign || undefined,
      }
      return params
    },
  },
  watch: {
    searchCampaign: helpers.debounce(function () {
      this.$nextTick(function () {
        this.getCampaigns()
      })
    }, 500),
  },
  beforeCreate() {

  },
  created() {
    this.getCampaigns()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getCampaigns() {
      (async () => {
        this.isEmpty = false
        this.isLoading = true
        let params = {
          ...this.getFilterParams
        }
        const response = await api.get(apiV2.taskManagerCampaignListPage, {needToken: true, params})
        if (response.status == 200) {
          this.maxPage = response.data.max_page
          this.campaigns = response.data.results
          if (!this.campaigns.length) {
            this.isEmpty = true
          } else {
            this.isEmpty = false
          }
        } else {
          this.$notify({
              group: 'saved',
              title: 'Error',
              text: `Sorry something went wrong! (Error code: ${response.status})`,
              type: 'warn'
            })
        }
        this.isLoading = false
      })();
    },
    selectPage(page) {
      this.selectedPage = page
    },
    newCampaign() {
      this.$router.push({ name: 'campaignmonitoringnew' })
    },
    goToDetail(id) {
      this.$router.push({ name: 'campaignmonitoringedit', params: {id: id} })
    },
    formatDate(start, end) {
      if (start && end) {
        const startFormat = moment(start, 'DD/MM/YYYY')
        const endFormat = moment(end, 'DD/MM/YYYY')
        return `${startFormat.format('DD MMM YYYY')} - ${endFormat.format('DD MMM YYYY')}`
      }
      return '-'
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
